import React from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom';
import ActivationModule from 'modules/Activation';
import AudienceModule from 'modules/Audience';
import CampaignModule from 'modules/Campaign';
import ContentsModule from 'modules/Contents';
import FunnelModule from 'modules/Funnel';
import GlobalModule from 'modules/Global';
import LLMModule from 'modules/LLM';
import PMLModule from 'modules/PML';

import Snowfall from 'react-snowfall';
import { useApp } from 'contexts/AppContext';
import { useUser } from 'contexts/UserContext';

import { localStorage, routes } from 'utils/constants';
import { routes as routesPolicies } from 'utils/policies';
import { IsUpMd as IsUpMdBreakpoint } from 'utils/responsive';

import AuthTokenContainer from 'containers/AuthContainer/AuthTokenContainer';
import LoginContainer from 'containers/AuthContainer/LoginContainer';
import DashboardContainer from 'containers/DashboardContainer';
import EasterEgg from 'containers/EasterEgg';
import FooterContainer from 'containers/FooterContainer';
import HeaderContainer from 'containers/HeaderContainer';

import { Item } from 'components/Layout';
import LayoutApp from 'components/LayoutApp';

const { AuthenticatedRoute } = routesPolicies;

function App() {
  const IsUpMd = IsUpMdBreakpoint();
  const { isAuthenticated, profile, isSuperAdmin } = useUser();
  const { isSimplify, isLoading, domainConfig } = useApp();
  const [isDecember] = React.useState(new Date().getMonth() === 11);
  if (isLoading) {
    return <></>;
  }

  const showLlm = () => {
    return process.env.REACT_APP_LLM?.toString() === '1' && isSuperAdmin;
  };

  const showPml = () => {
    return domainConfig?.domain !== ('ERMES' || 'INSTADATA');
  };

  const showFunnel = () => {
    return !domainConfig?.features.hideFunnelBo;
  };
  const adminModules = [
    {
      module: (
        <AuthenticatedRoute
          exact
          path={routes.FUNNEL}
          component={FunnelModule}
        />
      ),
      disabled: !showFunnel()
    },
    {
      module: (
        <AuthenticatedRoute
          exact
          path={routes.AUDIENCE}
          component={AudienceModule}
        />
      )
    },
    {
      module: (
        <AuthenticatedRoute
          exact
          path={routes.ACTIVATION}
          component={ActivationModule}
        />
      )
    },
    {
      module: (
        <AuthenticatedRoute exact path={routes.PML} component={PMLModule} />
      ),
      disabled: !showPml()
    },
    {
      module: (
        <AuthenticatedRoute
          exact
          path={routes.CAMPAIGN}
          component={CampaignModule}
        />
      )
    },
    {
      module: (
        <AuthenticatedRoute exact path={routes.LLM} component={LLMModule} />
      ),
      disabled: !showLlm()
    },
    {
      module: (
        <AuthenticatedRoute
          exact
          path={routes.CONTENTS}
          component={ContentsModule}
        />
      )
    }
  ];

  const getRedirectUrl = user => {
    const isSimplified = profile
      ? profile?.features?.isSimplified
      : user?.roles?.some(el => ['STANDARD', 'SELLER'].indexOf(el) !== -1);
    return isSimplified ? routes.GLOBAL : routes.DASHBOARD;
  };
  // There is marginTop because the HeaderContainer position is 'fixed'
  const styleHeaderFix = isAuthenticated
    ? { marginTop: IsUpMd ? '100px' : '245px' }
    : { marginTop: '0px' };
  // There is marginTop because the HeaderContainer position is 'fixed'
  return (
    <LayoutApp>
      <Router>
        <AuthTokenContainer
          publicRoutes={[routes.LOGIN, routes.DEFAULT]}
          redirectOnError={routes.DEFAULT}
        />
        {isAuthenticated && !isSimplify && isDecember && (
          <Snowfall
            style={{
              background: 'transparent',
              zIndex: 1200,
              position: 'fixed',
              width: '100%',
              height: '100%'
            }}
            snowflakeCount={150}
          />
        )}
        <HeaderContainer hideOnLocation={[routes.LOGIN, routes.LOGIN_ADMIN]} />
        <Item flex style={{ ...styleHeaderFix }}>
          <Switch>
            <Route
              exact
              path={routes.LOGIN}
              component={() => (
                <LoginContainer
                  authAdress="/auth/logIn"
                  localStorageConfig={{
                    refreshToken: localStorage.REFRESH_TOKEN,
                    accessToken: localStorage.ACCESS_TOKEN,
                    expireAt: localStorage.EXPIRE_AT,
                    adminToken: localStorage.ADMIN_TOKEN
                  }}
                  redirectTo={getRedirectUrl}
                  footerSize="50px"
                  headerSize="90px"
                />
              )}
            />
            <AuthenticatedRoute
              exact
              path={routes.DASHBOARD}
              component={DashboardContainer}
            />
            <AuthenticatedRoute
              exact
              path={routes.GLOBAL}
              component={GlobalModule}
            />
            {!isSimplify &&
              adminModules.reduce((acc, config) => {
                if (!config.disabled) {
                  acc.push(config.module);
                }
                return acc;
              }, [])}
            {/* ne pas mettre de nouveau modules en dessous de celui la sinon le redirect s'applique */}
            <AuthenticatedRoute
              path={routes.DEFAULT}
              component={() => <Redirect to={routes.LOGIN} />}
            />
          </Switch>
        </Item>
        <FooterContainer />
        {isAuthenticated && !isSimplify && <EasterEgg />}
      </Router>
    </LayoutApp>
  );
}

export default App;
